import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class DeepCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Deep Cleaning Gold Coast | Professional Property Cleaning"
          description="Deep cleaning Gold Coast services. Thorough sanitisation for homes, apartments and commercial properties."
          keywords="deep cleaning gold coast, professional deep cleaning gold coast, house deep cleaning gold coast, apartment deep cleaning gold coast, office deep cleaning gold coast, commercial deep cleaning gold coast, full property sanitisation gold coast, heavy duty cleaning gold coast, post construction cleaning gold coast, after renovation cleaning gold coast, mould removal cleaning gold coast, grout cleaning gold coast, tile scrubbing gold coast, oven deep cleaning gold coast, bathroom sanitisation gold coast, high traffic area cleaning gold coast, eco friendly deep cleaning gold coast, same day deep cleaning gold coast, urgent deep cleaning gold coast, professional sanitisation gold coast, disinfectant cleaning gold coast, detailed home cleaning gold coast, thorough house cleaning gold coast, industrial deep cleaning gold coast, reliable deep cleaners gold coast, affordable deep cleaning gold coast, complete property cleaning gold coast, hygiene focused cleaning gold coast, house reset cleaning gold coast, detailed office cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Deep Cleaning Gold Coast</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Deep Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Deep cleaning goes beyond routine surface cleaning.
                            It targets built up grime, hidden dust and bacteria
                            that accumulate over time. Our deep cleaning Gold
                            Coast service is ideal for homes and businesses
                            requiring thorough sanitisation.
                          </p>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            When Is Deep Cleaning Needed
                          </h4>
                          <ul className="list-check primary">
                            <li>After renovations</li>
                            <li>Before events</li>
                            <li>Seasonal refresh</li>
                            <li>Long overdue maintenance</li>
                            <li>Moving into a property</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Comprehensive Deep Cleaning Process
                          </h4>
                          <h5 className="m-b10">Kitchen</h5>
                          <ul className="list-check primary">
                            <li>Cleaning inside cabinets</li>
                            <li>Deep degreasing appliances</li>
                            <li>Cleaning splashbacks</li>
                            <li>Floor scrubbing</li>
                          </ul>

                          <h5 className="m-b10 m-t20">Bathrooms</h5>
                          <ul className="list-check primary">
                            <li>Removing mould and soap buildup</li>
                            <li>Descaling surfaces</li>
                            <li>Sanitising high touch areas</li>
                          </ul>

                          <h5 className="m-b10 m-t20">
                            Bedrooms and Living Areas
                          </h5>
                          <ul className="list-check primary">
                            <li>Cleaning under furniture</li>
                            <li>Dusting ceiling fans</li>
                            <li>Cleaning light fixtures</li>
                            <li>Detailed floor cleaning</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Commercial Deep Cleaning
                          </h4>
                          <p>We provide deep cleaning for:</p>
                          <ul className="list-check primary">
                            <li>Offices</li>
                            <li>Restaurants</li>
                            <li>Retail stores</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Our Deep Cleaning Service
                          </h4>
                          <ul className="list-check primary">
                            <li>Attention to detail</li>
                            <li>Experienced professionals</li>
                            <li>High quality equipment</li>
                            <li>Hygienic and safe cleaning solutions</li>
                          </ul>
                        </div>

                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Book Deep Cleaning Gold Coast Today
                          </h4>
                          <p>
                            Contact Kangaroo Shine Property Services for
                            professional deep cleaning Gold Coast.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default DeepCleaningGoldCoast;
